import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class SupportTicketMarkedAsResolved extends Notification {
  icon() {
    return 'fas fa-check';
  }

  href() {
    const notification = this.attrs.notification;
    const ticket = notification.subject();

    return app.route('ticketsView', { id: ticket.id() });
  }

  content() {
    return app.translator.trans('v17development-flarum-support.forum.notifications.ticket_resolved.content', {
      ticket_id: this.attrs.notification.subject().id(),
    });
  }
}
